import { XirpIcon, XirpLogo } from '@spotify/confidence-core-react';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { TransitionScreen } from '../../TransitionScreen';

import styles from './XirpEmailVerifiedPage.module.css';

const XirpEmailVerifiedPageComponent = () => {
  return (
    <div className={styles.root}>
      <div className={styles.branding}>
        <XirpLogo className={styles.mark} height={28} />
      </div>
      <TransitionScreen
        title="Email verified!"
        description="Your email has been verified. You can close this tab and return to the signup window."
        graphics={<XirpIcon className={styles.mark} size={120} />}
      />
    </div>
  );
};

export const XirpEmailVerifiedPage = withPageImpression(
  XirpEmailVerifiedPageComponent,
  { pageId: 'xirp-email-verified' },
);
